var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectbtnicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FEF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9179 12.0097L16.8194 8.10821C17.0732 7.85443 17.0732 7.44409 16.8194 7.19034C16.5656 6.93655 16.1552 6.93655 15.9015 7.19034L11.9999 11.0918L8.09854 7.19034C7.84463 6.93655 7.43444 6.93655 7.18066 7.19034C6.92676 7.44412 6.92676 7.85443 7.18066 8.10821L11.082 12.0097L7.18069 15.9112C6.92679 16.165 6.92679 16.5753 7.18069 16.8291C7.24089 16.8895 7.31242 16.9373 7.39118 16.97C7.46994 17.0026 7.55438 17.0194 7.63963 17.0193C7.80578 17.0193 7.97198 16.9557 8.09857 16.8291L11.9999 12.9276L15.9015 16.8291C15.9617 16.8895 16.0332 16.9373 16.112 16.97C16.1907 17.0026 16.2752 17.0194 16.3604 17.0193C16.5266 17.0193 16.6928 16.9557 16.8194 16.8291C17.0732 16.5753 17.0732 16.165 16.8194 15.9112L12.9179 12.0097Z",
    fill: "#E65757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectbtnicon);
export default __webpack_public_path__ + "static/media/rejectbtnicon.58318ded7146d22bfdbb530d2c0f4d80.svg";
export { ForwardRef as ReactComponent };